<template>
  <ol class="breadcrumbs">
    <li class="breadcrumb-item" v-for="item in items" :key="item.url">
      <a :href="item.url" class="breadcrumb-link" v-if="item.url && item.url.length > 0">{{
        item.label
      }}</a>
      <span v-else class="breadcrumb-text">{{ item.label }}</span>
    </li>
  </ol>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
